import { LogOut } from 'lucide-react'
import { Suspense, useEffect } from 'react'
import { Link } from 'react-router'
import { SuperNav } from '@/components/layout/side-nav/super-nav'
import { UserNav, UserNavSkeleton } from '@/components/layout/side-nav/user-nav'
import { ThemeSwitcher } from '@/components/layout/theme-switcher'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarTrigger,
  useSidebar,
} from '@/components/sv/sidebar'
import { useRBAC } from '@/lib/hooks'
import { cn } from '@/lib/utils'
import { SevallaLogoDark } from '@/logos'

export const SuperLayout = ({ children }: { children: React.ReactNode }) => {
  const { rbac } = useRBAC()
  const { isMobile } = useSidebar()

  useEffect(() => {
    rbac.kinsta().superadmin.ensure()
  }, [rbac])

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-3 bg-orange-500 px-4 py-1.5 text-sm font-medium text-white">
        <span>Superadmin mode</span>
        <Link
          to="/"
          className="inline-flex items-center gap-1 rounded-md bg-white/20 px-2 py-0.5 text-xs font-medium text-white transition-colors hover:bg-white/30"
        >
          <LogOut className="size-3" />
          Exit superadmin
        </Link>
      </div>
      <div
        className={cn(
          'w-full max-w-[1536px] mx-auto min-h-screen pt-8',
          'grid',
          isMobile ? 'grid-cols-1' : 'grid-cols-[16rem_minmax(0,1fr)]'
        )}
      >
        <Sidebar
          variant="inset"
          className="left-auto h-full border-r-[0px]! pt-8"
        >
          <SidebarHeader className="pt-4">
            <Link to="/superadmin" className="flex items-center gap-2">
              <SevallaLogoDark className="pl-2 w-32" />
            </Link>
          </SidebarHeader>
          <SidebarContent className="pt-4">
            <SuperNav />
          </SidebarContent>
          <SidebarFooter>
            <Suspense fallback={<UserNavSkeleton />}>
              <UserNav />
            </Suspense>
          </SidebarFooter>
        </Sidebar>
        <main>
          <header className="sticky z-20 top-0 bg-sidebar flex items-center gap-2 -ml-2 py-5 px-2">
            {isMobile ? <SidebarTrigger /> : null}
            <div className="ml-auto flex items-center gap-2">
              <ThemeSwitcher />
            </div>
          </header>
          <div className="p-2 pt-0">{children}</div>
        </main>
      </div>
    </>
  )
}
